import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

// Character-by-character scroll-reveal
// Each char's opacity goes 0.2 -> 1 based on scroll position over the paragraph
export function AnimatedText({
    children = "",
    className = "",
    style,
    "data-testid": testId,
}) {
    const ref = useRef(null);
    const { scrollYProgress } = useScroll({
        target: ref,
        offset: ["start 0.8", "end 0.2"],
    });

    const text = String(children);
    const chars = text.split("");

    return (
        <p ref={ref} className={`relative ${className}`} style={style} data-testid={testId}>
            {chars.map((ch, i) => (
                <Char key={`${i}-${ch}`} progress={scrollYProgress} range={[i / chars.length, (i + 1) / chars.length]}>
                    {ch}
                </Char>
            ))}
        </p>
    );
}

function Char({ children, progress, range }) {
    const opacity = useTransform(progress, range, [0.2, 1]);
    return (
        <motion.span style={{ opacity }} className="inline">
            {children}
        </motion.span>
    );
}
